import { CommandType } from "~app/common/services/cqs/CommandType";
import { DestineraArbetsorderHandelssortimentBaseCommand } from "./DestineraArbetsorderHandelssortimentBaseCommand";

export class DestineraArbetsorderHandelssortimentCommand extends DestineraArbetsorderHandelssortimentBaseCommand {
// eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "DestineraArbetsorderHandelssortimentCommand";

    constructor(arbetsorderId: number, destineringId: number, andel?: number) {
        super(DestineraArbetsorderHandelssortimentCommand.$type, CommandType.Replace);
        this.arbetsorderId = arbetsorderId;
        this.destineringId = destineringId;
        this.andel = andel;
    }
}
